import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoyaltyModule } from '@shared/core/modules/loyalty';

import { SubDrawComponent } from './sub-draw.shared.component';

@NgModule({
    declarations: [
        SubDrawComponent
    ],
    imports: [
        CommonModule,
        LoyaltyModule,
    ],
    exports: [
        SubDrawComponent
    ],
    providers: [],
})
export class SubDrawModule { }
